import { useEffect, useState } from "react";
import {
  addDoc,
  collection,
  deleteDoc,
  doc,
  getDocs,
  orderBy,
  query,
  serverTimestamp,
  updateDoc,
} from "firebase/firestore";
import { db } from "../../firebase";
import css from "./seriesAdmin.module.css";

export default function SeriesAdmin() {
  const [seriesList, setSeriesList] = useState([]);
  const [loading, setLoading] = useState(false);

  const [name, setName] = useState("");
  const [desc, setDesc] = useState("");
  const [sortOrder, setSortOrder] = useState("");
  const [isActive, setIsActive] = useState(true);

  const [editingId, setEditingId] = useState(null);

  const fetchSeries = async () => {
    setLoading(true);

    try {
      const q = query(collection(db, "series"), orderBy("sortOrder", "asc"));
      const snapshot = await getDocs(q);

      const data = snapshot.docs.map((docSnap) => ({
        id: docSnap.id,
        ...docSnap.data(),
      }));

      setSeriesList(data);
    } catch (error) {
      console.error("Помилка при отриманні серій:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSeries();
  }, []);

  const resetForm = () => {
    setName("");
    setDesc("");
    setSortOrder("");
    setIsActive(true);
    setEditingId(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!name.trim()) {
      alert("Введіть назву серії");
      return;
    }

    const payload = {
      name: name.trim(),
      desc: desc.trim(),
      sortOrder: Number(sortOrder) || 999,
      isActive,
      updatedAt: serverTimestamp(),
    };

    try {
      if (editingId) {
        await updateDoc(doc(db, "series", editingId), payload);
      } else {
        await addDoc(collection(db, "series"), {
          ...payload,
          createdAt: serverTimestamp(),
        });
      }

      resetForm();
      fetchSeries();
    } catch (error) {
      console.error("Помилка при збереженні серії:", error);
    }
  };

  const handleEdit = (item) => {
    setEditingId(item.id);
    setName(item.name || "");
    setDesc(item.desc || "");
    setSortOrder(item.sortOrder || "");
    setIsActive(item.isActive !== false);

    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const handleDelete = async (id) => {
    const confirmDelete = window.confirm("Ви точно хочете видалити цю серію?");

    if (!confirmDelete) return;

    try {
      await deleteDoc(doc(db, "series", id));
      fetchSeries();
    } catch (error) {
      console.error("Помилка при видаленні серії:", error);
    }
  };

  return (
    <div className={css.seriesAdminWrap}>
      <h1 className={css.title}>Серії книг</h1>

      <form className={css.form} onSubmit={handleSubmit}>
        <label className={css.label}>
          Назва серії
          <input
            className={css.input}
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Наприклад: Я граюся, я вчуся"
          />
        </label>

        <label className={css.label}>
          Опис серії
          <textarea
            className={css.textarea}
            value={desc}
            onChange={(e) => setDesc(e.target.value)}
            placeholder="Опис серії"
          />
        </label>

        <label className={css.label}>
          Порядок виводу
          <input
            className={css.input}
            type="number"
            value={sortOrder}
            onChange={(e) => setSortOrder(e.target.value)}
            placeholder="1"
          />
        </label>

        <label className={css.checkboxLabel}>
          <input
            type="checkbox"
            checked={isActive}
            onChange={(e) => setIsActive(e.target.checked)}
          />
          Показувати серію на сайті
        </label>

        <div className={css.buttonsWrap}>
          <button className={css.submitBtn} type="submit">
            {editingId ? "Оновити серію" : "Додати серію"}
          </button>

          {editingId && (
            <button className={css.cancelBtn} type="button" onClick={resetForm}>
              Скасувати
            </button>
          )}
        </div>
      </form>

      <div className={css.listWrap}>
        <h2 className={css.subtitle}>Список серій</h2>

        {loading && <p>Завантаження...</p>}

        {!loading &&
          seriesList.map((item) => (
            <div key={item.id} className={css.seriesItem}>
              <div className={css.seriesContent}>
                <div className={css.seriesTop}>
                  <h3>{item.name}</h3>
                  <span>#{item.sortOrder || 999}</span>
                </div>

                <p>{item.desc}</p>

                <div className={css.status}>
                  {item.isActive === false ? "Прихована" : "Активна"}
                </div>
              </div>

              <div className={css.actions}>
                <button type="button" onClick={() => handleEdit(item)}>
                  Редагувати
                </button>

                <button type="button" onClick={() => handleDelete(item.id)}>
                  Видалити
                </button>
              </div>
            </div>
          ))}
      </div>
    </div>
  );
}
